import { render, staticRenderFns } from "./searchHistoryInput.vue?vue&type=template&id=300d56bc&scoped=true&"
import script from "./searchHistoryInput.vue?vue&type=script&lang=js&"
export * from "./searchHistoryInput.vue?vue&type=script&lang=js&"
import style0 from "./searchHistoryInput.vue?vue&type=style&index=0&id=300d56bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300d56bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('300d56bc')) {
      api.createRecord('300d56bc', component.options)
    } else {
      api.reload('300d56bc', component.options)
    }
    module.hot.accept("./searchHistoryInput.vue?vue&type=template&id=300d56bc&scoped=true&", function () {
      api.rerender('300d56bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledgeBaseMgr/knowledgeSearch/components/searchHistoryInput.vue"
export default component.exports